import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import PageLoader from '@/components/feature/PageLoader';
import NotFound from '@/pages/NotFound';

const Home = lazy(() => import('@/pages/home/page'));
const Nosotros = lazy(() => import('@/pages/nosotros/page'));
const Servicios = lazy(() => import('@/pages/servicios/page'));
const Portafolio = lazy(() => import('@/pages/portafolio/page'));
const ValeRegalo = lazy(() => import('@/pages/vale-regalo/page'));
const Paquetes = lazy(() => import('@/pages/paquetes/page'));
const PiezasUnicas = lazy(() => import('@/pages/piezas-unicas/page'));
const Reservar = lazy(() => import('@/pages/reservar/page'));
const Admin = lazy(() => import('@/pages/admin/page'));
const AvisoLegal = lazy(() => import('@/pages/aviso-legal/page'));
const PoliticaPrivacidad = lazy(() => import('@/pages/politica-privacidad/page'));
const PoliticaCookies = lazy(() => import('@/pages/politica-cookies/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: '/nosotros',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Nosotros />
      </Suspense>
    ),
  },
  {
    path: '/servicios',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Servicios />
      </Suspense>
    ),
  },
  {
    path: '/portafolio',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Portafolio />
      </Suspense>
    ),
  },
  {
    path: '/vale-regalo',
    element: (
      <Suspense fallback={<PageLoader />}>
        <ValeRegalo />
      </Suspense>
    ),
  },
  {
    path: '/paquetes',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Paquetes />
      </Suspense>
    ),
  },
  {
    path: '/piezas-unicas',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PiezasUnicas />
      </Suspense>
    ),
  },
  {
    path: '/reservar',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Reservar />
      </Suspense>
    ),
  },
  {
    path: '/admin',
    element: (
      <Suspense fallback={<PageLoader />}>
        <Admin />
      </Suspense>
    ),
  },
  {
    path: '/aviso-legal',
    element: (
      <Suspense fallback={<PageLoader />}>
        <AvisoLegal />
      </Suspense>
    ),
  },
  {
    path: '/politica-privacidad',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PoliticaPrivacidad />
      </Suspense>
    ),
  },
  {
    path: '/politica-cookies',
    element: (
      <Suspense fallback={<PageLoader />}>
        <PoliticaCookies />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;